module.exports = __webpack_public_path__ + "img/W-G02.6e298ede.jpg";